import styled from 'styled-components'
import { themeStyles } from '../../../styles/theme'

export const ResponsibleGamingContainer = styled.div`
  display: flex;
  order: 3;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.75rem;
  background-color: ${themeStyles.colors.black.main};
  color: ${themeStyles.colors.white.main};
`

export const ResponsibleGamingText = styled.span`
  font-size: 12px;
  text-align: center;
  line-height: 1.44;
  width: 80%;
  max-width: 400px;
  margin: 0;
`

export const ResponsibleGamingLogo = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  max-width: 40%;
  img {
    width: 35px;
    margin: 5px;
  }
`
export const ResponsibleGamingLogoText = styled.span`
  margin-left: 5px;
  line-height: 1.44;
  margin: 10px 0px 10px 0;
  font-size: 12px;
  font-weight: 700;
  text-align: left;
`
export const ResponsibleGamingLogos = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  width: 75%;
  margin: 0;
  gap: 10px;
  max-width: 400px;
`
